export enum PaymentType {
  CreditCard = "CREDIT_CARD",
  ACH = "ACH",
  Check = "CHECK",
  Credit = "CREDIT",
  ManualCheck = "MANUAL_CHECK",
  Cash = "CASH",
  OtherElectronic = 'OTHER_ELECTRONIC'
}

export enum FundingSourceType {
  Org = "ORG",
  Vendor = "VENDOR",
  Payee = "PAYEE",
}

export enum FundingSourceStatus {
  Verified= "VERIFIED",
  UnVerified = "UNVERIFIED",
  Pending = "PENDING",
  Removed = "REMOVED",
  Inactive = "INACTIVE",
  MicroDepositInitiated = "MICRO_DEPOSIT_INITIATED",
  MicroDepositVerificationInitiated = "MICRO_DEPOSIT_VERIFICATION_INITIATED"
}

export enum DisbursementType {
  Cash = 'CASH',
  Check = 'CHECK',
  ACH = 'ACH',
  OtherElectronic = 'OTHER_ELECTRONIC'
}

